import { render } from "./ChooseTeam.vue?vue&type=template&id=88a27702"
import script from "./ChooseTeam.vue?vue&type=script&lang=js"
export * from "./ChooseTeam.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__